// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import { Swipe, SwipeItem } from 'vant';
import './theme/element/index.css';
import App from './App'
import router from './router'
import store from './store'

Vue.config.productionTip = false

Vue.use(ElementUI)

Vue.use(Swipe);
Vue.use(SwipeItem);

document.querySelector('html').style.fontSize = '16px'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})

router.afterEach((to,from,next)=>{
  window,scrollTo(0,0)
})



// WEBPACK FOOTER //
// ./src/main.js